import React from "react";

/**
 * Paperclip Icon
 * Used for attachment button in the notes section
 */
const PaperclipIcon = React.memo(() => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M11.5083 3.53242L5.7583 9.28242C4.91664 10.1241 4.91664 11.4824 5.7583 12.3241C6.59996 13.1657 7.95829 13.1657 8.79996 12.3241L14.5416 6.58242C15.8083 5.31575 15.8083 3.22408 14.5416 1.95742C13.275 0.690752 11.1833 0.690752 9.91663 1.95742L4.17496 7.69075C2.42496 9.44075 2.42496 12.2991 4.17496 14.0491C5.92496 15.7991 8.78329 15.7991 10.5333 14.0491L16.25 8.33242" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
));

export default PaperclipIcon; 